package com.yogaaicoach.pages.trainingprogram

// Mirrors composeApp's Weekday enum (pages/trainingprogram/add/WeekdayStateModel.kt) — strips
// the StringResource title/description/shortTitle fields (Compose-resource-coupled), since the
// jsMain pages hold their own plain display strings, same pattern used for MainGoal/LevelKey.
// No custom serializer in source, so this uses kotlinx.serialization's default enum-name wire
// format ("Monday", "Tuesday", ...) — must match composeApp's wire format exactly since the
// backend doesn't know which client sent the request.
enum class Weekday {
    Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday
}
